import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import {
  Translate,
  withLocalize,
} from "react-localize-redux";
import { useHistory } from "react-router-dom";
import AvatarIcon from "../resources/AvatarIcon";
import { MiniLogo } from "../components/MiniLogo";
import { BwtButton, BwtButtons } from "../components/BwtButton";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "48px",
      fontWeight: "bold",
      letterSpacing: "1.2px",
      textAlign: "center",
      color: "var(--col-navy-500)",
    },
    titleContainer: {
      display: "flex",
      paddingTop: "40px",
      paddingBottom: "30px",
      justifyContent: "center",
      flexDirection: "column",
    },
    buttonRoot: {
      height: "34px",
    },
    topBar: {
      display: "flex",
      justifyContent: "space-between",
      padding: "15px 10px 0 10px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "24px",
      padding: "0 24px",
    },
  })
);


const TermsAndConditionsPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Translate>
      {({ translate }) => (
        <div>
          <div className={classes.topBar}>
            <Button
              classes={{ root: classes.buttonRoot }}
              onClick={() => {
                history.push("/");
              }}
            >
              <AvatarIcon color="var(--col-navy-500)" />
            </Button>
            <MiniLogo />
          </div>

          <div className={classes.titleContainer}>
            <span className={classes.title}>
              {translate("profile.termsAndConditions")}
            </span>
          </div>

          <div className={classes.buttonContainer}>
            <BwtButton
              label="BWT Best Water App"
              styleType={BwtButtons.pink}
              onClick={() =>
                history.push(`${history.location.pathname}/BWTBestWaterApp`)
              }
            />
            <BwtButton
              label={translate("proAppTermsAndConditions.titleLine2").toString()}
              styleType={BwtButtons.pink}
              onClick={() =>
                history.push(`${history.location.pathname}/BWTProApp`)
              }
            />
          </div>
        </div>
      )}
    </Translate>
  );
};

export default withLocalize(TermsAndConditionsPage);
